import { render } from "./profileChangePasswordComponent.vue?vue&type=template&id=05b50d28&scoped=true"
import script from "./profileChangePasswordComponent.vue?vue&type=script&lang=js"
export * from "./profileChangePasswordComponent.vue?vue&type=script&lang=js"

import "./profileChangePasswordComponent.vue?vue&type=style&index=0&id=05b50d28&scoped=true&lang=scss"
import "./profileChangePasswordComponent.vue?vue&type=style&index=1&id=05b50d28&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b50d28"]])

export default __exports__